var map = {
	"./amazon.svg": 40618,
	"./apple.svg": 45536,
	"./baidu.svg": 11682,
	"./battlenet.svg": 86037,
	"./discord.svg": 10797,
	"./epicgames.svg": 87082,
	"./facebook.svg": 59836,
	"./github.svg": 43997,
	"./google.svg": 57508,
	"./kakao.svg": 19323,
	"./linkedin.svg": 88374,
	"./mailru.svg": 68377,
	"./microsoft.svg": 65900,
	"./msn.svg": 66396,
	"./naver.svg": 36346,
	"./ok.svg": 4581,
	"./paypal.svg": 58259,
	"./qq.svg": 47375,
	"./reddit.svg": 92143,
	"./steam.svg": 99275,
	"./three-dots.svg": 52762,
	"./twitch.svg": 26927,
	"./twitter.svg": 93413,
	"./vimeo.svg": 2061,
	"./vk.svg": 17687,
	"./wechat.svg": 51957,
	"./weibo.svg": 36596,
	"./xbox.svg": 17002,
	"./yahoo.svg": 10567,
	"./yandex.svg": 16929,
	"./youtube.svg": 92733
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46140;